import { B2Button } from 'react-b2components';
import styled from 'styled-components';

export const RemoveImageButton = styled(B2Button)`
  color: ${(props) => props.theme.colors.error};
`;
